import { UPDATE_MEMBER_COMMON_STATUS } from "../mutation.type";
import Vue from "vue";
const state = {
  status_store: {},
};

const mutations = {
  [UPDATE_MEMBER_COMMON_STATUS]: (state, { key, value }) => {
    Vue.set(state.status_store, key, value);
  },
};

export default {
  state,
  mutations,
};
